import { AddressAutocomplete } from "@/components/AddressAutocomplete";
import { useTranslation } from "@/hooks/useTranslation";
import type { CardSelectorAddressFormProps } from "./CardSelectorProps";

export function CardSelectorAddressForm({
  config,
}: CardSelectorAddressFormProps) {
  const t = useTranslation("card_selector");

  const addressConfig = config["card-selector-address-fields"];

  return (
    <AddressAutocomplete
      name="cardSelector.postCardAddress"
      fieldsConfig={{
        "address-line-1": {
          label: t(addressConfig["address-line-1"].label.i18n) as string,
          serverErrorPath: "card_selector.recipient.address_line_1",
          name: "postCardAddress.address-line-1",
          isRequired: addressConfig["address-line-1"]["is-required"],
        },
        "address-line-2": {
          label: t(addressConfig["address-line-2"].label.i18n) as string,
          serverErrorPath: "card_selector.recipient.address_line_2",
          name: "postCardAddress.address-line-2",
          isRequired: addressConfig["address-line-2"]["is-required"],
        },
        city: {
          label: t(addressConfig.city.label.i18n) as string,
          serverErrorPath: "card_selector.recipient.city",
          name: "postCardAddress.city",
          isRequired: addressConfig.city["is-required"],
        },
        "postal-code": {
          label: t(addressConfig["postal-code"].label.i18n) as string,
          serverErrorPath: "card_selector.recipient.postal_code",
          name: "postCardAddress.postal-code",
          isRequired: addressConfig["postal-code"]["is-required"],
        },
        region: {
          label: t(addressConfig.region.label.i18n) as string,
          serverErrorPath: "card_selector.recipient.region",
          name: "postCardAddress.region",
          isRequired: addressConfig.region["is-required"],
        },
        country: {
          label: t(addressConfig.country.label.i18n) as string,
          serverErrorPath: "card_selector.recipient.country",
          name: "postCardAddress.country",
          isRequired: addressConfig.country["is-required"],
        },
      }}
    />
  );
}
